import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import Home from './components/Home';
import About from './components/About';
import ValuedCustomers from './components/ValuedCustomers';
import Contact from './components/Contact';

import 'bootstrap/dist/css/bootstrap.min.css';

import './css/fader.css';
import './css/general.css';
import './css/site.css';
import Template from './components/Template';
import TechTalk from './components/TechTalk';
import BusinessContinuity from './components/BusinessContinuity';
import TechnologySupport from './components/TechnologySupport';
import CustomApplications from './components/CustomApplications';
import SupportRequest from './components/SupportRequest';
import FuelingSuccess from './components/FuelingSuccess';
import ITSupportNetworkAudit from './components/ITSupportNetworkAudit';
import Regex from './components/Regex';

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Layout>
            <Route exact path='/' component={Home} />
            <Route path='/about' component={About} />
            <Route path='/valued-customers' component={ValuedCustomers} />
            <Route path='/template' component={Template} />
            <Route path='/contact-us' component={Contact} />
            <Route path='/tech-talk' component={TechTalk} />
            <Route path='/business-continuity' component={BusinessContinuity} />
            <Route path='/technology-support' component={TechnologySupport} />
            <Route path='/custom-applications' component={CustomApplications} />
            <Route path='/support-request' component={SupportRequest} />
            <Route path='/fueling-success' component={FuelingSuccess} />
            <Route path='/it-support-network-audit' component={ITSupportNetworkAudit} />
            <Route path='/regex' component={Regex} />
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js